import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface UseEmailUpdateReturn {
  updateEmail: (newEmail: string) => Promise<void>;
  isLoading: boolean;
}

function mapErrorMessage(message: string | undefined): string {
  if (!message) return "Failed to update email. Please try again.";
  if (message.includes("already registered") || message.includes("already in use")) {
    return "This email address is already associated with another account.";
  }
  return message || "Failed to update email. Please try again.";
}

export function useEmailUpdate(): UseEmailUpdateReturn {
  const [isLoading, setIsLoading] = useState(false);

  const updateEmail = async (newEmail: string): Promise<void> => {
    setIsLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ email: newEmail });
      if (error) {
        toast.error(mapErrorMessage(error.message));
      } else {
        toast.success("Confirmation email sent. Please check your inbox to complete the change.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { updateEmail, isLoading };
}
